import React from "react";
import { Box } from "@material-ui/core";
import type { CoreCruisesCheckout } from "redmond";

import { CruiseCheckoutLayout } from "./components/CruiseCheckoutLayout";

export interface ICruiseBookProps {
  core?: CoreCruisesCheckout;
}

/**
 * CruiseBook — cruise checkout page.
 *
 * Renders the scaffolded checkout layout (main checkout-steps column beside a
 * sticky summary sidebar), threading down the `core` payload the host supplies
 * from `useCruisesCheckoutProps()`. The individual sections (traveler/cabin
 * assignment, rewards & payment, the summary, …) and their data wiring
 * (`fetchUserPassengers`, the cabin-pricing quote, the booking call) get built
 * in piece by piece.
 */
export const CruiseBook = ({ core }: ICruiseBookProps) => (
  <Box className="cruise-book-root">
    <CruiseCheckoutLayout core={core} />
  </Box>
);
